import {
  useReadManyNotificationMutation,
  useReadNotificationMutation,
} from "@ac-expo/api";
import { UserWithRoles } from "@ac-expo/api-types";
import { useSyncedCart } from "@ac-expo/hooks";
import { BellIcon, NotificationPopover, RedDot } from "@ac-expo/ui-components";
import OwnImage from "@ui/components/ui/event/OwnImage";
import { useUserContext } from "@web-app/src/context/auth/user.context";
import { useMessageContext } from "@web-app/src/context/websocket/message.context";
import { useNotificationContext } from "@web-app/src/context/websocket/notifications.context";
import { getFileUrl } from "@web-app/src/shared/files";
import GlobalSearch from "@web-app/src/shared/GlobalSearch";
import Link from "next/link";
import { useRouter } from "next/router";
import { SvgWeb } from "../../../../public/images/svg/SvgWeb";
import filterStore from "../../../services/FilterStore";
import AddEvent from "../../Event/AddEvent";
import UserPopover from "../UserPopover";
import { AuthButtons } from "./AuthButtons";

type NavMenuDesktopProps = {
  handleCartClick: () => void;
  user?: UserWithRoles;
};

export const NavMenuDesktop = ({
  handleCartClick,
  user,
}: NavMenuDesktopProps) => {
  const router = useRouter();
  const { isAuthenticated } = useUserContext();
  const { haveNewMessage } = useMessageContext();
  const { hasItems } = useSyncedCart({ basketType: "store", isAuthenticated });

  return (
    <>
      <nav className="hidden h-[72px] w-full items-center border-b border-gray-200 bg-white px-16 dark:bg-gray-900 lg:flex">
        <div className="flex h-[44px] w-full items-center gap-12 py-3.5">
          {/* Logo Section */}
          <Link href={"/"}>
            <button
              onClick={() => {
                filterStore.resetStore();
                filterStore.setShowMap(false);
              }}
            >
              <div className="flex h-[32px] ">
                <OwnImage
                  src="/images/logos/logo_connect_events_horizontale.png"
                  alt="logo avec nom Connect'Events"
                  className="static h-9 w-auto p-1"
                  width={880}
                  height={200}
                />
              </div>
            </button>
          </Link>

          <div className="grow">
            <GlobalSearch />
          </div>

          <div className="flex items-center justify-between gap-8">
            {user && !user.isGuestCheckout ? (
              <>
                <AddEvent />
                <button
                  onClick={handleCartClick}
                  className="relative"
                  aria-label="Mon panier"
                >
                  <SvgWeb name="bag" alt="bag" width={20} height={20} />
                  {hasItems && (
                    <RedDot className="absolute -right-0.5 top-0 size-2" />
                  )}
                </button>
                <Link href={"/conversations"} className="relative">
                  <SvgWeb
                    name="chatCircle"
                    alt="chatCircle"
                    width={20}
                    height={20}
                  />
                  {haveNewMessage && (
                    <RedDot className="absolute -right-0.5 top-0 size-2" />
                  )}
                </Link>
                <NotificationPopover
                  navigateTo={router.push}
                  getFileUrl={getFileUrl}
                  useNotificationContext={useNotificationContext}
                  useReadManyNotificationMutation={
                    useReadManyNotificationMutation
                  }
                  useReadNotificationMutation={useReadNotificationMutation}
                  bellIcon={<BellIcon width={24} height={24} />}
                />{" "}
              </>
            ) : (
              <div className="flex justify-end">
                <AuthButtons handleCartClick={handleCartClick} />
              </div>
            )}

            {user && !user.isGuestCheckout && <UserPopover />}
          </div>
        </div>
      </nav>
    </>
  );
};
